// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatLoader__biEGX {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.isLoading__EZ8fy {
  position: relative;
}
.isLoading__EZ8fy:before {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  top: 2px;
  left: 2px;
  z-index: 12;
  border-radius: 50%;
  background-color: var(--tables-primary-row-surface-default);
}
.isLoading__EZ8fy:after {
  content: "";
  width: 12px;
  height: 12px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  border-radius: 50px 0 0 0;
  background-color: var(--buttons-surface);
  opacity: 0;
  animation: loading__JE1rS 1s linear infinite;
}

.sendBtn__XODt0 {
  cursor: pointer;
}

.active__sBB3S > path {
  fill: var(--buttons-surface);
}

.disabled__UsYBP {
  pointer-events: none;
  opacity: 0.7;
}

.loadingSendBtn__x0VpG {
  width: 16px;
  height: 16px;
  background-color: var(--buttons-surface);
  border: 4px solid var(--tables-primary-row-surface-default);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  border-radius: 50%;
  opacity: 1;
  animation: sendBtnLoader__FSGY4 1s;
}
.loadingSendBtn__x0VpG > path {
  fill: var(--buttons-surface);
}

@keyframes sendBtnLoader__FSGY4 {
  0% {
    width: 16px;
    height: 16px;
  }
  100% {
    background-color: var(--buttons-surface);
    border: 4px solid var(--tables-primary-row-surface-default);
  }
}
@keyframes loading__JE1rS {
  0% {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: rotate(90deg);
  }
  100% {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: rotate(450deg);
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ChatComponent/components/SendBtnWithLoader/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;AA2EE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,2DAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,wCAAA;EACA,UAAA;EACA,4CAAA;AA1EJ;;AA8EA;EACE,eAAA;AA3EF;;AA+EE;EACE,4BAAA;AA5EJ;;AAgFA;EACE,oBAAA;EACA,YAAA;AA7EF;;AAgFA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,2DAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kCAAA;AA7EF;AA+EE;EACE,4BAAA;AA7EJ;;AAiFA;EACE;IACE,WAAA;IACA,YAAA;EA9EF;EAiFA;IACE,wCAAA;IACA,2DAAA;EA/EF;AACF;AAkFA;EACE;IACE,UAAA;IACA,2BAAA;IACA,wBAAA;EAhFF;EAkFA;IACE,UAAA;IACA,2BAAA;IACA,yBAAA;EAhFF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chatLoader {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.isLoading {\n  position: relative;\n\n  &:before {\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    z-index: 12;\n    border-radius: 50%;\n    background-color: var(--tables-primary-row-surface-default);\n  }\n\n  &:after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 11;\n    border-radius: 50px 0 0 0;\n    background-color: var(--buttons-surface);\n    opacity: 0;\n    animation: loading 1s linear infinite;\n  }\n}\n\n.sendBtn {\n  cursor: pointer;\n}\n\n.active {\n  & > path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.loadingSendBtn {\n  width: 16px;\n  height: 16px;\n  background-color: var(--buttons-surface);\n  border: 4px solid var(--tables-primary-row-surface-default);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 20;\n  border-radius: 50%;\n  opacity: 1;\n  animation: sendBtnLoader 1s;\n\n  & > path {\n    fill: var(--buttons-surface);\n  }\n}\n\n@keyframes sendBtnLoader {\n  0% {\n    width: 16px;\n    height: 16px;\n  }\n\n  100% {\n    background-color: var(--buttons-surface);\n    border: 4px solid var(--tables-primary-row-surface-default);\n  }\n}\n\n@keyframes loading {\n  0% {\n    opacity: 1;\n    transform-origin: 100% 100%;\n    transform: rotate(90deg);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 100% 100%;\n    transform: rotate(450deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatLoader": `chatLoader__biEGX`,
	"isLoading": `isLoading__EZ8fy`,
	"loading": `loading__JE1rS`,
	"sendBtn": `sendBtn__XODt0`,
	"active": `active__sBB3S`,
	"disabled": `disabled__UsYBP`,
	"loadingSendBtn": `loadingSendBtn__x0VpG`,
	"sendBtnLoader": `sendBtnLoader__FSGY4`
};
module.exports = ___CSS_LOADER_EXPORT___;
